// data structure

export default class AppConfiguration {
  static set(key, value) {
    try {
      const strOrNumber = (() => {
        if (typeof value === "object") {
          return JSON.stringify(value);
        } else {
          return value;
        }
      })();

      localStorage.setItem(key, strOrNumber);
    } catch (error) {
      console.error("AssetStorage.get() error - JSON parsing error");
    }
  }

  static get(key) {
    try {
      const str = localStorage.getItem(key);
      return JSON.parse(str);
    } catch {
      return localStorage.getItem(key);
    }
  }
}
